<template>
  <div class="px-10 text-center">
    <div class="text-h5">Paso a paso</div>
    <div class="text-body-1">(alterna entre TPV y ordenador)</div>

    <v-img src="/i/purchase-step1.svg" width="33%" class="mt-8 mx-auto" />
    <div class="text-h6">1. Prepárate</div>
    <div>(ordenador)</div>
    <p class="mt-1">En primer lugar, invierte el tiempo justo para configurar tu cuenta y cargar tus productos desde el back-office.</p>

    <v-img src="/i/purchase-step2.svg" width="33%" class="mt-8 mx-auto" />
    <div class="text-h6">2. Opera</div>
    <div>(TPV)</div>
    <p class="mt-1">A partir de aquí, activa tu día a día: toma nota, cobra, imprime recibos y cierra tus ventas.</p>

    <v-img src="/i/purchase-step3.svg" width="33%" class="mt-8 mx-auto" />
    <div class="text-h6">3. Monitoriza</div>
    <div>(TPV)</div>
    <p class="mt-1">En paralelo y en cualquier momento, sigue el estado de tu restaurante y de tus pedidos desde el mismo dispositivo.</p>

    <v-img src="/i/purchase-step4.svg" width="33%" class="mt-8 mx-auto" />
    <div class="text-h6">4. Analiza</div>
    <div>(ordenador)</div>
    <p class="mt-1">Y por último, examina tus ventas y tu negocio en profundidad para ajustar decisiones y mejorar.</p>
  </div>
</template>

<script>
  // import I18n from '@/Mixins/I18n'

  export default {
    mixins: [
      // I18n,
    ],
  }
</script>
